module.exports = __webpack_public_path__ + "static/media/logo-parallels.da272cb9.svg";